/**
 * Currencies supported for employee compensation.
 *
 * Kept intentionally small (BRL + USD) — add a new entry here and every
 * consumer (schema validation, employees table, employee details, exports)
 * picks it up automatically.
 */

export const EMPLOYEE_CURRENCIES = [
  { value: "BRL", label: "Real (R$)", symbol: "R$", locale: "pt-BR" },
  { value: "USD", label: "Dólar (US$)", symbol: "US$", locale: "en-US" },
] as const;

export const EMPLOYEE_CURRENCY_CODES = ["BRL", "USD"] as const;

export type EmployeeCurrency = (typeof EMPLOYEE_CURRENCY_CODES)[number];

export const DEFAULT_EMPLOYEE_CURRENCY: EmployeeCurrency = "BRL";

export function isEmployeeCurrency(value: unknown): value is EmployeeCurrency {
  return (
    typeof value === "string" && (EMPLOYEE_CURRENCY_CODES as readonly string[]).includes(value)
  );
}

export function getCurrencyLabel(value: string | null | undefined): string {
  if (!value) return "";
  return EMPLOYEE_CURRENCIES.find((c) => c.value === value)?.label ?? value;
}
